

























































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import FileData from '@/domain/FileData'
import CsvRequest from '@/domain/CsvRequest'
import CsvResponse from '@/domain/CsvResponse'
import CsvResponsesService from '@/service/CsvResponsesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class MemberRequestCsv extends Mixins(GlobalMixin) {
  csvResponsesService = CsvResponsesService.instance

  errors: string[] = []
  importFileSelected = false
  importFile: FileData | undefined = undefined

  /**
   * 依頼ファイルの登録ボタンのクリック
   */
  onImport(event: Event) {
    this.alertBarIsVisible = false
    if (this.importFile !== undefined) {
      const header = CsvResponse.getHeader().join(",")
      const csvErrors = this.validateImportCsv(this.importFile.content)
      if (csvErrors.length !== 0) {
        /* CSVフォーマットエラー */
        this.errors = csvErrors
        this.alert("依頼ファイルの読み込みでエラーが発生しました", ALERT_TYPE.ERROR)
      } else {
        const fileName = "FromBVI" + this.dateTimeUtils.format("yyMMdd_HHmm_status5.csv")
        const csvData = this.parseImportCsv(this.importFile.content)
        const csvDataStatus5 = this.convertStatus5(csvData)
            .map(x => x.toCsv(","))
            .reduce((p, x) => p + "\r\n" + x, header)
        const status5File = this.convertFile(fileName, "text/csv", csvDataStatus5)
        this.showLoading()
        this.csvResponsesService.upload(this.convertStatus7(csvData))
          .then(() => {
            this.hideLoading()
            this.download(status5File)
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * インポートファイルの選択
   */
  onChangeImportFile(file: File | undefined) {
    this.importFile = undefined
    this.importFileSelected = false
    if (file !== undefined && file.name.toLowerCase().slice(-4) === ".csv") {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === "string") {
          this.importFile = {filename: file.name, content: reader.result}
          this.importFileSelected = true
        }
      }
      reader.readAsText(file, "SJIS")
    }
  }

  /**
   * CSV依頼データのCSVフォーマットバリデーション
   */
  private validateImportCsv(data: string): string[] {
    const errors: string[] = []
    data.split("\r\n").filter((x, index) => index === 0)
        .forEach(x => {
          if (x !== CsvRequest.getHeader().join("|")) {
            errors.push("ヘッダ行が違っています")
          }
        })
    if (errors.length === 0) {
      data.split("\r\n").map(x => x.length === 0 ? 34 : x.split("|").length)
          .forEach((x, index) => {
            if (x !== 34) {
              errors.push(`${index +1} 行目の項目数が不正です`)
            }
          })
    }
    return errors
  }

  /**
   * CSV依頼データのパース
   */
  private parseImportCsv(data: string): CsvRequest[] {
    return data.split("\r\n")
        .filter((x, index) => index !== 0)
        .filter(x => x.length > 0)
        .map(x => {
            const row = x.split("|")
            return new CsvRequest({
                requestId: row[0],
                status: row[1],
                lastModifiedAt: row[2],
                cancelOn: row[3],
                cancelReason: row[4],
                requestRegistrationOn: row[5],
                recommendedScheduledOn: row[6],
                requestConfirmationOn: row[7],
                arriveOn: row[8],
                specimenNo: row[9],
                productName: row[10],
                category: row[11],
                edibleWeight: row[12],
                optionSingle: row[13],
                optionInspection1: row[14],
                optionInspection2: row[15],
                optionInspection3: row[16],
                optionInspection4: row[17],
                additive1: row[18],
                additive2: row[19],
                additive3: row[20],
                additive4: row[21],
                additive5: row[22],
                additive6: row[23],
                excludedParts: row[24],
                note: row[25],
                inspectionType: row[26],
                laboratoryName: row[27],
                companyName: row[28],
                factoryName: row[29],
                writer: row[30],
                manufacturerTel: row[31],
                vendorCode: row[32],
                customerCode: row[33],
                unitOfEdibleWeight: row[34],
        })
    })
  }

  /**
   * 依頼データのコンバート（ステータス５用）
   */
  private convertStatus5(src: CsvRequest[]): CsvResponse[] {
    const requestConfirmationOn = this.dateUtils.getToday().replace(/-/g, "")
    const deliveryOn = new Date(this.dateTimeUtils.getNowTime() + 1000 * 60 * 60 * 24 * 8).toISOString().substr(0, 10).replace(/-/g, "")
    return src.map(x => {
      return new CsvResponse({
          requestId: x.requestId,
          status: "5",
          lastModifiedAt: x.lastModifiedAt,
          requestConfirmationOn: requestConfirmationOn,
          deliveryOn: deliveryOn,
      })
    })
  }

  /**
   * 依頼データのコンバート（ステータス７用）
   */
  private convertStatus7(src: CsvRequest[]): CsvResponse[] {
    const requestConfirmationOn = this.dateUtils.getToday().replace(/-/g, "")
    const deliveryOn = new Date(this.dateTimeUtils.getNowTime() + 1000 * 60 * 60 * 24 * 8).toISOString().substr(0, 10).replace(/-/g, "")
    return src.map(x => {
      return new CsvResponse({
          requestId: x.requestId,
          status: "7",
          lastModifiedAt: x.lastModifiedAt,
          requestConfirmationOn: requestConfirmationOn,
          deliveryOn: deliveryOn,
          requestRegistrationOn: x.requestRegistrationOn,
          recommendedScheduledOn: x.recommendedScheduledOn,
          companyFactoryName: `${x.companyName}/${x.factoryName}` ,
          productName: x.productName,
          category: x.category,
          edibleWeight: x.edibleWeight,
          additive1: x.additive1,
          additive2: x.additive2,
          additive3: x.additive3,
          additive4: x.additive4,
          additive5: x.additive5,
          additive6: x.additive6,
          excludedParts: x.excludedParts,
          calorie100gUnit: "kcal/100g",
          calorie1mealUnit: "kcal/1食当り",
          protein100gUnit: "g/100g",
          protein1mealUnit: "g/1食当り",
          lipid100gUnit: "g/100g",
          lipid1mealUnit: "g/1食当り",
          carbohydrate100gUnit: "g/100g",
          carbohydrate1mealUnit: "g/1食当り",
          sodium100gUnit: "mg/100g",
          sodium1mealUnit: "mg/1食当り",
          moisture100gUnit: "g/100g",
          moisture1mealUnit: "g/1食当り",
          ash100gUnit: "g/100g",
          ash1mealUnit: "g/1食当り",
      })
    })
  }

}
